import React from 'react';
import { Route, Routes } from "react-router-dom";

import { Skeleton } from './components/ui/skeleton';
import { AuthContext } from './contexts/AuthContext/AuthContext';
import * as Pages from './pages';

class AppRoutes extends React.Component {
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;

    componentDidMount() {
        this.context.initAppSession().then();
    }

    render() {
        if (!this.context.isAuthLoaded) {
            return <div className="flex min-h-screen flex-col dark:bg-gray-900">
                <div className="h-20 overflow-visible">
                    <div className="h-[10rem] bg-linear-180 from-gpas-700/70 dark:from-gpas-700/60 to-gpas-700/0"></div>
                    <Skeleton className="fixed z-10 top-2 inset-x-4 h-16 border dark:border-slate-700/70 max-w-screen-md mx-auto rounded-full"></Skeleton>
                </div>
            </div>
        }


        return (
            <Routes>
                <Route path='/bienvenidos' element={<Pages.WelcomePage />} />
                <Route path='/signin-callback' element={<Pages.SigninCallbackPage />} />
                <Route path='/esperando-aprobacion' element={<Pages.WelcomeWaitingForApproval />} />

                {/* Priveate Routes */}
                <Route path='/' element={<Pages.HomePage />} />
                <Route path='/estudios' element={<Pages.StudiesPage />} />
                <Route path='/estudios/:slug' element={<Pages.SingleStudyPage />} />
                <Route path='/recursos' element={<Pages.ResourcesPage />} />
                <Route path='/noticias/:slug' element={<Pages.NewsSinglePage />} />
                <Route path='/cerrar-sesion' element={<Pages.SignOutPage />} />

                {/* Admin */}
                <Route path='/gestion-usuarios' element={<Pages.UserDetailsForAdminPage />} />
            </Routes>
        )
    }
}

export default AppRoutes;